import { connect } from 'react-redux'
import Component from './Component'

const mapStateToProps = (state) => ({
  totals: state.screens.RetentionPayments.totals,
})

const actionCreators = {}

export default connect(mapStateToProps, actionCreators)(Component)